import { types } from '../../../constants/ActionTypes'
import { webBoardModeType } from '../../../constants'

const initialState = {
  mode: webBoardModeType.EDIT,
  openNewBoardCnfDlg: false,
  openSaveCnfDlg: false,
  openChangeNameCnfDlg: false,
  boardTitle: '',
}

const storeBoardCard = (state = initialState, action) => {
  switch (action.type) {
    case types.webBoard.REFRESH:
      return { ...state, mode: action.changeMode ? webBoardModeType.EDIT : state.mode }
    case types.webBoard.fileTitleCard.CHANGED_MODE:
      return { ...state, mode: action.mode }
    case types.webBoard.confirmDialog.OPEN:
      return { ...state, ['open' + action.name]: true }
    case types.webBoard.confirmDialog.CLOSE:
      return { ...state, ['open' + action.name]: false }
    case types.webBoard.confirmDialog.CHANGED_TEXT:
      if (action.name === 'boardTitle' && action.text.length > 20) {
        return state
      }
      return { ...state, [action.name]: action.text }
    case types.storeBoardCard.recordMenu.EDIT:
      return { ...state, mode: webBoardModeType.EDIT }
    default:
      return state
  }
}

export default storeBoardCard


// WEBPACK FOOTER //
// ./src/reducers/Page/WebBoard/WebBoard.js